import { useFormik } from "formik";
import { useGetBillToMappingBasicDataQuery } from "../../../../store/queries/Master";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { updateConfig } from "../../../../store/slices/BillToMapping/billToMappingSlice";

const useFilter = () => {
  const billToMappingState = useSelector((state) => state.billToMapping);
  const dispatch = useDispatch();
  const { data: basicData = {} } = useGetBillToMappingBasicDataQuery({});
  const supplierValues = Array.isArray(billToMappingState?.filter?.supplier)
    ? billToMappingState.filter.supplier
    : billToMappingState?.filter?.supplier
    ? [billToMappingState.filter.supplier]
    : [];
  const shopValues = Array.isArray(billToMappingState?.filter?.shop)
    ? billToMappingState.filter.shop
    : billToMappingState?.filter?.shop
    ? [billToMappingState.filter.shop]
    : [];
  const billToValues = Array.isArray(billToMappingState?.filter?.bill_to)
    ? billToMappingState.filter.bill_to
    : billToMappingState?.filter?.bill_to
    ? [billToMappingState.filter.bill_to]
    : [];

  const formik = useFormik({
    initialValues: {
      supplier: supplierValues,
      shop: shopValues,
      bill_to: billToValues,
    },
    onSubmit: (values) => {
      dispatch(
        updateConfig((state) => {
          state.showFilter = false;
          state.currentPage = 1;
          state.filter.supplier = values?.supplier;
          state.filter.shop = values?.shop;
          state.filter.bill_to = values?.bill_to;
        })
      );
    },
  });

  const handleReset = () => {
    formik?.handleReset();
    dispatch(
      updateConfig((state) => {
        state.showFilter = false;
        state.currentPage = 1;
        state.filter.supplier = [];
        state.filter.shop = [];
        state.filter.bill_to = [];
      })
    );
  };

  return {
    formik,
    basicData,
    handleReset,
  };
};

export default useFilter;
